import { serverInfo } from '../config/serverConfig';
import { apiFetch } from "./apiFetch";

/**
 * Update the signed-in user's working hours (Bearer auth via apiFetch).
 * @param {{ use_organization_default?: boolean, working_hours_start?: string, working_hours_end?: string, working_hours_time_zone?: string|null }} body
 */
export async function updateMyWorkingHours(body) {
  const res = await apiFetch(`${serverInfo.serverUrl}/updateMyWorkingHours`, {
    method: 'POST',
    body: JSON.stringify({ ...body }),
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    data = {};
  }
  if (!res.ok) {
    const msg = (data && data.message) || text || `Request failed (${res.status})`;
    throw new Error(typeof msg === 'string' ? msg : 'Request failed');
  }
  return data;
}
